module.exports = {"dagre":{"ranksep":30,"nodesep":30},"nodes":{"showLabels":true,"allowParameterChanges":true,"allowGraphChanges":true,"showToolbar":true,"size":{"width":139,"height":90}}}


//////////////////
// WEBPACK FOOTER
// ./src/components/SupplyNetwork/json/graph-options-fullsize.json
// module id = rNU0
// module chunks = 1